<script lang="ts">
    import Shelf from '@amp/web-app-components/src/components/Shelf/Shelf.svelte';
    import type {
        ArrowOffset,
        GridType,
    } from '@amp/web-app-components/src/components/Shelf/types';
    import { getI18n } from '~/stores/i18n';

    const i18n = getI18n();

    type T = $$Generic;

    export let items: T[];
    export let gridType: GridType;
    export let itemHasMargin: boolean = false;
    export let gridRows: number = 1;
    export let arrowOffset: ArrowOffset = null;

    // This makes the let:item of type T, because it doesn't know type when it comes back from the Shelf component.
    function castGenericItem(x: T): T {
        return x;
    }
</script>

<div class:shelf={!itemHasMargin}>
    <Shelf translateFn={$i18n.t} {items} {gridType} {gridRows} {arrowOffset}>
        <div slot="item" let:item let:index let:numberOfItems>
            <slot item={castGenericItem(item)} {index} {numberOfItems} />
        </div>
    </Shelf>
</div>

<style lang="scss">
    @use '@amp/web-shared-styles/app/core/globalvars' as *;

    .shelf {
        padding-bottom: $global-shelf-spacer-bottom;
    }
</style>
